import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Shield, Mail, Calendar } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { toast } from "sonner";

export default function ProfilePage() {
  const { user, refreshUser } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [password, setPassword] = useState("");
  const [saving, setSaving] = useState(false);

  if (!user) return null;

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = { name };
      if (password) payload.password = password;
      await api.put(`/users/${user.id}`, payload);
      toast.success("Perfil atualizado");
      setPassword("");
      await refreshUser();
    } catch (err) {
      toast.error(errMsg(err, "Erro ao atualizar"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6 max-w-2xl" data-testid="profile-page">
      <div>
        <div className="text-[10px] tracking-[0.2em] uppercase font-semibold" style={{ color: "#FF8A00" }}>Sua conta</div>
        <h2 className="font-display font-bold text-3xl mt-1 text-[#1F1F24]">Perfil</h2>
        <p className="text-gray-600 text-sm mt-1">Informações pessoais e ajustes de acesso.</p>
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-6">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full flex items-center justify-center text-white font-bold text-xl" style={{ backgroundColor: "#FF8A00" }}>
            {user.name.slice(0,1).toUpperCase()}
          </div>
          <div>
            <div className="font-display font-bold text-xl text-[#1F1F24]">{user.name}</div>
            <div className="text-sm text-gray-500 flex items-center gap-1.5"><Mail className="w-3.5 h-3.5" /> {user.email}</div>
            <div className="text-xs text-gray-500 mt-1 flex items-center gap-3">
              <span className="inline-flex items-center gap-1"><Shield className="w-3 h-3" /> {user.role === "admin" ? "Administrador" : "Membro"}</span>
              <span className="inline-flex items-center gap-1"><Calendar className="w-3 h-3" /> Membro desde {new Date(user.created_at).toLocaleDateString("pt-BR")}</span>
            </div>
          </div>
        </div>
      </div>

      <form onSubmit={submit} className="bg-white border border-gray-200 rounded-xl p-6 space-y-4">
        <h3 className="font-display font-semibold text-lg">Editar informações</h3>
        <div>
          <Label htmlFor="profile-name">Nome</Label>
          <Input id="profile-name" data-testid="profile-input-name" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div>
          <Label htmlFor="profile-password">Nova senha</Label>
          <Input id="profile-password" data-testid="profile-input-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Deixe em branco para manter" />
        </div>
        <Button type="submit" disabled={saving} className="vp-btn-primary text-white" data-testid="profile-save-btn">
          {saving ? "Salvando..." : "Salvar alterações"}
        </Button>
      </form>
    </div>
  );
}
